export default __webpack_public_path__ + "static/media/add_document_icon.a4f952db.svg";